import React, { useEffect, useState } from 'react';
import { ShlLinkContext } from '../Contexts';
import { getShlFromFragment } from '../utils/shlUrlUtil';

/**
 * Keeps the SHL context synchronized with the browser URL.
 * @param {object} props Props accepted by the component.
 * @param {React.ReactNode} props.children Viewer content.
 * @returns {import('react').FunctionComponent} The SHL context provider.
 */
function ShlLinkProvider({ children }) {
  const [shl, setShl] = useState(() => getShlFromFragment(window.location));

  useEffect(() => {
    const syncShl = () => {
      setShl(getShlFromFragment(window.location));
    };

    window.addEventListener('hashchange', syncShl);
    window.addEventListener('popstate', syncShl);

    return () => {
      window.removeEventListener('hashchange', syncShl);
      window.removeEventListener('popstate', syncShl);
    };
  }, []);

  return (
    <ShlLinkContext.Provider value={shl}>{children}</ShlLinkContext.Provider>
  );
}

export default ShlLinkProvider;
